import PropTypes from 'prop-types';
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap";
import SimpleBar from "simplebar-react";

//Import images
import avatar3 from "../../../assets/images/users/avatar-3.jpg";
import avatar4 from "../../../assets/images/users/avatar-4.jpg";

//i18n
import { withTranslation } from "react-i18next";
import { get, put } from 'helpers/api_helper';
import { loadHeaderFeed, setHeaderFeed } from 'helpers/headerFeedCache';

import moment from 'moment';
import SafeHTML from "components/buttons/SafeHTML";

class NotificationDropdown extends Component {
  constructor(props) {
    super(props)
    this.state = {
      menu: false,
    }
    this.toggle = this.toggle.bind(this)
  }

  toggle() {
    this.setState(prevState => ({
      menu: !prevState.menu,
    }))
  }
  fetchNotification() {
    const params = {
      ForId: localStorage.getItem('userId'),
      For: 'Agent',
      ForDays: 30
    };
    loadHeaderFeed("notifications", () => get(`Notification/allNew`, { params }))
      .then((response) => {
        if (this.alive) this.setState({ notificationsData: response, loading: false });
      })
      .catch((error) => {
        if (this.alive) this.setState({ error: error.message, loading: false });
      });
  }
 handleClearAllNotifications = () => {
  const data = {
    notificationViewed: true,
    ForId: parseInt(localStorage.getItem('userId')),
    for: "Agent",
    agentId: parseInt(localStorage.getItem('userId')),
  };

  put(`Notification/UpdateNotificationViewed`, data)
    .then(() => {
      setHeaderFeed("notifications", [])
      this.setState({ notificationsData: [], loading: false });
    })
    .catch((error) => {
      this.setState({ error: error.message, loading: false });
    });
};

  componentDidMount() {
    this.alive = true
    if (localStorage.getItem("isChangePasswordRequired") === "true") return
    this.fetchNotification();
  }
  componentWillUnmount() {
    this.alive = false
  }
  render() {
    return (
      <React.Fragment>
        <Dropdown
          isOpen={this.state.menu}
          toggle={this.toggle}
          className="dropdown d-inline-block"
          tag="li"
        >
          <DropdownToggle
            className="btn header-item noti-icon"
            tag="button"
            id="page-header-notifications-dropdown"
          >
            <i className="bx bx-bell bx-tada text-black" />
            <span className="badge bg-danger rounded-pill">{this.state.notificationsData?.length || 0}</span>
          </DropdownToggle>

          <DropdownMenu className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
            <div className="p-3" style={{ backgroundColor: "#03002E" }}>
              <Row className="align-items-center">
                <Col>
                  <h6 className="m-0 text-white"> {this.props.t("Notifications")} </h6>
                </Col>
                <div className="col-auto">
                  <Link to="/notification" className="small text-white">
                    {" "}
                    View All
                  </Link>
                </div>
              </Row>
            </div>

            <SimpleBar style={{ height: "230px" }}>
              {this.state.notificationsData && this.state.notificationsData.map((notification, index) => {
                const createdOnDate = moment(notification.notificationDate);
                const isToday = createdOnDate.isSame(moment(), 'day');
                return (
                  <div key={index} className="text-reset notification-item">
                    <div className="media">

                      <div className="media-body">
                        <div className="font-size-12">
                          <p className="mb-1">
                            <SafeHTML html={notification?.notificationText} />
                          </p>
                          <p className="mb-0">
                            <i className="mdi mdi-clock-outline" />{" "}
                             {createdOnDate.format('h:mm A')}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })}

            </SimpleBar>
            <div className="p-2 border-top d-grid">
              <Link className="btn btn-sm btn-link font-size-14 float-end" to="#" onClick={this.handleClearAllNotifications}>
                <i className="mdi mdi-arrow-right-circle me-1"></i> <span key="t-view-more">{this.props.t("Clear All")}</span>
              </Link>
            </div>
          </DropdownMenu>
        </Dropdown>
      </React.Fragment>
    )
  }
}

NotificationDropdown.propTypes = {
  t: PropTypes.any
}

export default withTranslation()(NotificationDropdown)
